export default "__VITE_ASSET__D_3_GS0x__"